import CONSTANTS from '../../constants'
import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader'
import type { MongoDBReopenRequest } from '../../types/mongodb'

const { MONGODB_API_URL } = CONSTANTS

const reopenMongoDB = async (payload: MongoDBReopenRequest): Promise<void> => {
	const query = new URLSearchParams({ mongoDBID: payload.mongoDBID }).toString()
	const response = await fetchWithAuthorizationHeader(
		`${MONGODB_API_URL}?${query}`,
		{
			method: 'POST',
			headers: { 'Content-Type': 'application/json', action: 'REOPEN' },
			body: JSON.stringify(payload)
		}
	)
	const data = await response.json()
	if (!response.ok) {
		throw new Error(
			data.error?.message ||
				data.message ||
				'Unable to complete the MongoDB request.'
		)
	}
	if (data.FailedEntryCount !== 0) {
		throw new Error('The MongoDB request was not accepted.')
	}
}

export default reopenMongoDB
